<div class="identi-page-wrapper pb-5">
  <app-product-hero
    [level]="productLevels.Level1"
    title="{{ plan1Name }}"
    subtitle="{{ heroSubtitle }}"
    (onBuyClick)="buyIdentibasePlusSubscription()"
    (onCompareClick)="compareClick()"
    [compareVisible]="buyButtonVisible"
    [levelsVisible]="true"
    [buyHidden]="!buyButtonVisible"
    [disabled]="!hasIdentibasePlusOption && isAuthenticated"
    badgeUri="/assets/images/identibase/identibasePlus/hero-badge-5.svg"
  ></app-product-hero>

  <div class="row py-4 light-background">
    <div class="col-12 text-center px-3">
      <div class="row row-cols-lg-5 row-cols-md-5 row-cols-2 mt-1 px-lg-5 px-md-3 px-sm-1 d-flex justify-content-center">
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identibasePlus/puzzle-icon.svg"
            alt="puzzle-icon"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2" [innerHTML]="plan1FeatureText1"></h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identiAlert/alert-badge.svg"
            alt="alert-badge"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2" [innerHTML]="plan1FeatureText2"></h6>
        </div>
        <div class="col text-center my-2">
          <img
          class="feature-icon"
          src="/assets/images/identibase/identibasePlus/helpline.svg"
          alt="helpline"
        />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2" [innerHTML]="plan1FeatureText3"></h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identibasePlus/one-plan.svg"
            alt="one-plan"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            <p class="mb-0" [innerHTML]="plan1FeatureText4"></p>
          </h6>
        </div>
      </div>
      <button
        *ngIf="buyButtonVisible"
        (click)="buyIdentibasePlusSubscription()"
        type="button"
        class="btn blue-button mt-lg-4 mt-md-3 mt-sm-2"
        [disabled]="!hasIdentibasePlusOption && isAuthenticated"
      >
        Buy now
      </button>
    </div>
  </div>

  <div class="row pt-5 mid-background" *ngIf="buyButtonVisible">
    <div class="col-12 text-center position-relative">
      <h3 class="mb-3">When your pet goes missing, you panic. Every minute matters.</h3>
      <a *ngIf="hasIdentiAlertOption" [routerLink]="[]" (click)="buyIdentiAlertSubscription()"
        >Upgrade to {{ plan2Name }}</a
      >
      <a *ngIf="!hasIdentiAlertOption && isAuthenticated" [routerLink]="plan2Route">Upgrade to {{ plan2Name }}</a>
      <h5 class="mt-3 mb-5">
        The most effective way to find your <br> missing pet for just {{ plan2YearlyPrice }} a year.
      </h5>
    </div>
  </div>

  <div class="d-none d-md-block">
    <app-subscription-table-desktop
      id="subscription-table"
      [identibasePlusButtonLabel]="'Buy now'"
      [identialertButtonLabel]="'Learn more'"
      [basicPlusHighlighted]="true"
      [buyButtonVisible]="buyButtonVisible"
      [buyButtonDisabled]="!hasIdentibasePlusOption && isAuthenticated"
      (identitableButtonClicked)="onIdentitableButtonClicked($event)"
    ></app-subscription-table-desktop>
  </div>
  <div class="d-block d-md-none">
    <app-subscription-table-mobile
      id="subscription-table"
      [identibasePlusButtonLabel]="'Buy now'"
      [identialertButtonLabel]="'Learn more'"
      [basicPlusHighlighted]="true"
      [buyButtonVisible]="buyButtonVisible"
      [buyButtonDisabled]="!hasIdentibasePlusOption && isAuthenticated"
      (identitableButtonClicked)="onIdentitableButtonClicked($event)"
    ></app-subscription-table-mobile>
  </div>
</div>
